// extracted by mini-css-extract-plugin
export var blog_page_title = "index-module--blog_page_title--fd32e";
export var category_blog = "index-module--category_blog--37dda";
export var category_blog_container = "index-module--category_blog_container--d1c08";